<template>
  <v-autocomplete
    :search-input.sync="search"
    :items="items"
    v-model="model"
    item-value="id"
    item-text="code_descr"
    return-object
    :label="$t('Packaging')"
    :loading="loading"
    prepend-inner-icon="widgets"
    hide-no-data
    @dblclick="search = '?'"
  ></v-autocomplete>
</template>

<script>
import { debounce } from 'lodash';
import { suggest }  from '@/resources';

export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      loading: false,
      search: '',
      items: [],
      model: {}
    }
  },
  methods: {
    suggestImpl(search) {
      search && search.trim() !== '' && this.querySelections(search);// && search !== this.model.code_descr
    },
    init() {
      this.model = JSON.parse(JSON.stringify(this.value));
      this.search = this.model && this.model.code_descr;
    },
    querySelections(filter) {
      if (this.loading)
        return;
      this.loading = true;

      suggest.packagingDgs({
        filter
      }).then(res => {
        this.items = res.body.suggestions;
      }).catch(err => {
        console.log('Cannot load packagings', err);
        this.items = [];
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  created() {
    this.suggest = debounce(this.suggestImpl, 500);
  },
  mounted() {
    (!this.model || this.model && !this.model.id) && (this.value && this.value.id) && this.init();
  },
  watch: {
    search(val) {
      if (!val || !val.trim())
        return;
      this.suggest(val);
      if (val === '?') {
        this.search = '';
      }
    },
    value(val) {
      //(!this.model || this.model && !this.model.id) && this.init();
    },
    model(val) {
      this.$emit('input', val);
    }
  }
}
</script>
